// B端职位管理接口
import request from './request'

// 编辑职位
export function editPosition(data) {
  return request({
    url: '/api/position/edit',
    method: 'post',
    data
  })
}

// 获取单个职位详情
export function getJobInfo(params) {
  return request({
    url: '/api/position/getJobInfo',
    method: 'get',
    params
  })
}

// 职位列表
export function getPositionList(params) {
  return request({
    url: '/api/position/list',
    method: 'get',
    params
  })
}

// 发布职位
export function publishPosition(data) {
  return request({
    url: '/api/position/publish',
    method: 'post',
    data
  })
}

// 修改职位状态
export function updateJobStatus(data) {
  return request({
    url: '/api/position/changeStatus',
    method: 'post',
    data
  })
}